import { ConsumptionCertificateStepController } from './ConsumptionCertificateStep.controller'
import { DynamicFlowStep } from 'components/common/DynamicFlow'
import { FC } from 'react'
import { PurchaseFlowStepKey } from '../../../_main/contexts'
import { useConsumptionCertificateStep } from './ConsumptionCertificateStep.context'

/**
 * @component
 * Page in PurchaseFlow step for consumption certificate information.
 * 
 * @example 
 * <ConsumptionCertificateStep />
 */
export const ConsumptionCertificateStep: FC = () => {

  const {
    isPropertyInformationValid,
    isHeatingSystemValid,
    isConsumptionInformationValid,
    isAdditionalInformationValid
  } = useConsumptionCertificateStep()

  const isValid = isPropertyInformationValid && isHeatingSystemValid && isConsumptionInformationValid && isAdditionalInformationValid

  return (
    <DynamicFlowStep
      stepKey={PurchaseFlowStepKey.CONSUMPTION_CERTIFICATE}
      isValid={isValid}
    >
      <ConsumptionCertificateStepController />
    </DynamicFlowStep>
  )
}
